export const defaults = {
    // Default to Civic's production endpoint
    endpoint: "https://api.civic.com/identity-store/",
};
export class UpdateStoreDataError extends Error {
    constructor(message, alreadyLinkedToDids) {
        super(message);
        this.name = "UpdateStoreDataError";
        this.alreadyLinkedToDids = alreadyLinkedToDids;
        Object.setPrototypeOf(this, UpdateStoreDataError.prototype);
    }
}
